import GraphTemplateSelector from "connected-components/graph/components/template-selector"
import GraphPanelPeriodControl from "connected-components/graph/components/panel-period-control"

// No viewModifiedActions prop: Beta has no resolvable metric family, so GraphWrapper never builds it for Beta.
export default function BetaHeader() {
  return (
    <>
      <GraphTemplateSelector />
      <GraphPanelPeriodControl isPerformance={false} />
    </>
  )
}
